import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";
import { privacyContent, getDateLocale } from "../translations/legalContent";

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      titleKey="privacyTitle"
      renderContent={(lang) => {
        const content = privacyContent[lang] || privacyContent.tr;
        const locale = getDateLocale(lang);

        return (
          <>
            <p>
              {content.lastUpdatedLabel} {new Date().toLocaleDateString(locale)}
            </p>

            {content.sections.map((section, i) => (
              <section key={i}>
                <h2>{section.title}</h2>
                {section.paragraphs?.map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
                {section.items && (
                  <ul>
                    {section.items.map((item, k) => (
                      <li key={k}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </>
        );
      }}
    />
  );
}
